import { APP_INITIALIZER, DEFAULT_CURRENCY_CODE, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router, RouteReuseStrategy } from '@angular/router';
import { NativeStorage } from '@ionic-native/native-storage/ngx';
import { ThemeDetection } from '@ionic-native/theme-detection/ngx';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { DeviceDetectorService } from 'ngx-device-detector';
import { CookieService } from 'ngx-cookie-service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { NavigationComponent } from './_interfaces/navigation/navigation.component';
import { JwtInterceptor } from './_interceptor/jwt.interceptor';
import { AddTicketPageModule } from './_template/popup-content/add-ticket/add-ticket.module';
import { KundenPopoverPageModule } from './_template/popover/kunden-popover/kunden-popover.module';
import { TicketArtSelectPageModule } from './_template/ticket-more/ticket-detail-allgemein/ticket-art-select/ticket-art-select.module';
import { PopoverPageModule } from './_template/popover/popover.module';
import { AnsprechpartnerPopoverPageModule } from './_template/popover/ansprechpartner-popover/ansprechpartner-popover.module';
import { TimeOverviewBasePageModule } from './_template/time-overview/time-overview-base/time-overview-base.module';
import { AddTimePageModule } from './_template/ticket-more/ticket-detail-zeiten/add-time/add-time.module';
import { SplashComponent } from './_template/splash/splash.component';
import { SetupPageModule } from './_pages/setup/setup.module';
import { ReleaseLicensePageModule } from './_template/release-license/release-license.module';
import { AddContactPersonPageModule } from './_template/crm-detail/add-contact-person/add-contact-person.module';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { ArtPopoverPageModule } from './_template/popover/art-popover/art-popover.module';
import { ComponentsModule } from './components/components.module';
import { HotkeyModule } from 'angular2-hotkeys';
import { Vibration } from '@awesome-cordova-plugins/vibration/ngx';
import { TapticEngine } from '@awesome-cordova-plugins/taptic-engine/ngx';
import { Zeroconf } from '@awesome-cordova-plugins/zeroconf/ngx';


import { QuillModule } from "ngx-quill";
import { OneSignal } from "@awesome-cordova-plugins/onesignal/ngx"
import { SignPageModule } from './_pages/sign/sign.module';
import { SignPreviewPageModule } from './_pages/sign/sign-preview/sign-preview.module';
import { MultiselectPageModule } from './_template/popover/multiselect/multiselect.module';
import { ClientErrorService } from './_errorHandlers/clienterror.service';
import { AppAvailability } from '@awesome-cordova-plugins/app-availability/ngx';
import { HotkeyCheatsModule } from './_interfaces/navigation/hotkeys/hotkeys.module';
import * as SentryAngular from "@sentry/angular";

import localeDe from '@angular/common/locales/de';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localeDe);


@NgModule({
    declarations: [
        AppComponent,
        NavigationComponent,
        SplashComponent
    ],
    imports: [
        HttpClientModule,
        BrowserModule,
        IonicModule.forRoot(),
        HotkeyModule.forRoot(),
        QuillModule.forRoot(),
        AppRoutingModule,
        AddTicketPageModule,
        KundenPopoverPageModule,
        TicketArtSelectPageModule,
        PopoverPageModule,
        MultiselectPageModule,
        AnsprechpartnerPopoverPageModule,
        TimeOverviewBasePageModule,
        SetupPageModule,
        ArtPopoverPageModule,
        AddTimePageModule,
        SignPageModule,
        SignPreviewPageModule,
        HotkeyCheatsModule,
        ComponentsModule,
        ReleaseLicensePageModule,
        AddContactPersonPageModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            // Register the ServiceWorker as soon as the app is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        })
    ],
    providers: [
        SplashScreen,
        StatusBar,
        NativeStorage,
        ThemeDetection,
        CookieService,
        Vibration,
        Zeroconf,
        OneSignal,
        AppAvailability,
        TapticEngine,
        AndroidPermissions,
        DeviceDetectorService,
        { provide: ErrorHandler, useValue: SentryAngular.createErrorHandler()},
        { provide: APP_INITIALIZER, useFactory: () => () => {}, deps: [SentryAngular.TraceService], multi: true },
        { provide: SentryAngular.TraceService, deps: [Router] },
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: LOCALE_ID, useValue: 'de' },
        { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}